import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';

export const AUTHENTICATION_TYPES = {
    externalMfa: 'DUO MFA',
    externalIdp: formatMessage(Locale.loginProvider),
};

export const EXTERNAL_IDP = { displayName: formatMessage(Locale.loginProvider), categoryId: 'externalIdp' };
export const EXTERNAL_MFA = { displayName: '2 Factor MFA', categoryId: 'externalMfa' };

export const AUTHENTICATION_STATUSES = {
    active: 'Enabled',
    disabled: 'Disabled',
};

export const EXTERNAL_IDP_REQUIRED_FORM_FIELDS = ['clientName', 'clientId', 'responseType', 'authority'];
export const DUO_MFA_REQUIRED_FORM_FIELDS = ['name', 'secretKey', 'clientId', 'host'];
export const AUTH_PROVIDER_ENABLE_DIALOG = 'AUTH_PROVIDER_ENABLE_DIALOG';
export const AUTH_PROVIDER_DISABLE_DIALOG = 'AUTH_PROVIDER_DISABLE_DIALOG';
export const AUTH_PROVIDER_DELETE_DIALOG = 'AUTH_PROVIDER_DELETE_DIALOG';
export const AUTH_PROVIDER_EDIT_ASSIGNED_USERS_DIALOG = 'AUTH_PROVIDER_EDIT_ASSIGNED_USERS_DIALOG';

export const AUTH_PROVIDER_EDIT_ASSIGNED_USERS_DIALOG_RADIO_NAME = 'AuthProviderEditAssignedUsersDialogRadio';
export const ENABLE_LOCAL_LOGIN = 'enableLocalLogin';
export const DISABLE_USERS = 'disableUsers';
export const DELETE_USERS = 'deleteUsers';
export const MOVE_USERS = 'moveUsers';

export const AUTHENTICATION_PROVIDER_ACTIONS = {
    enable: 'Enable',
    disable: 'Disable',
    delete: 'Delete',
};

export const CONFIGURE_DUO_MFA_STEP_INDEX = 0;
export const CONFIGURE_EXTERNAL_IDP_STEP_INDEX = 0;
export const ASSIGN_USERS_STEP_INDEX = 1;

export const UNASSIGN_USERS_OPTIONS = {
    enableLocalLogin: 'enableLocalLogin',
    disableUsers: 'disableUsers',
    deleteUsers: 'deleteUsers',
    moveUsers: 'moveUsers',
};

export const ADD_DUO_MFA = 'ADD_DUO_MFA';
export const EDIT_DUO_MFA = 'EDIT_DUO_MFA';
export const ADD_EXTERNAL_IDP = 'ADD_EXTERNAL_IDP';
export const EDIT_EXTERNAL_IDP = 'EDIT_EXTERNAL_IDP';

export const ADD_IDENTITY_PROVIDER_DRAWER = 'ADD_IDENTITY_PROVIDER_DRAWER';
export const EDIT_IDENTITY_PROVIDER_DRAWER = 'EDIT_IDENTITY_PROVIDER_DRAWER';
export const EDIT_IDENTITY_PROVIDER_USERS_TAB = 'EDIT_IDENTITY_PROVIDER_USERS_TAB';
export const ADD_DUO_MFA_DRAWER = 'ADD_DUO_MFA_DRAWER';
export const EDIT_DUO_MFA_DRAWER = 'EDIT_DUO_MFA_DRAWER';

export const YOUR_EXISTING_SECRET = 'YOUR_EXISTING_SECRET';

export const DISABLE_AUTHENTICATION = 'disable_authentication';
export const ENABLE_AUTHENTICATION = 'enable_authentication';
export const DELETE_AUTHENTICATION = 'delete_authentication';
export const WHEEL = 'wheel';
export const BOTTOM = 'bottom';
export const APPLICATION_MORE = 'Application_More';

export const IDP_ICON_PATH = 'Cloud';
export const MFA_ICON_PATH = 'Status_Locked';

export const ENABLE = 'enable';
export const DISABLE = 'disable';
export const CANCEL = 'cancel';
export const FORGET = 'forget';

export const SCHEME = 'scheme';
export const MFAID = 'mfaId';

export const ADD_PROVIDER_BUTTON = 'addProviderButton';
export const ADD_EXTERNAL_IDP_BUTTON = 'addExternalIdpButton';
export const ADD_DUO_MFA_BUTTON = 'addDuoMfaButton';
export const ADD_PROVIDER_FLYOUT = 'addProviderFlyout';
export const LOADING_CARDS_COUNT = 3;
export const INFO_AUTHENTICATION_LINK =
    'https://docs.connectwise.com/ConnectWise_Unified_Product/ConnectWise_Home/040#Authentication';

export default ADD_IDENTITY_PROVIDER_DRAWER;
